/** 在线客服-本地开发 */
// export const KF_BACKEND = 'http://127.0.0.1:19020'
/** 在线客服-测试环境 */
// export const KF_BACKEND = 'http://192.168.0.108:19020'
/** 在线客服-生产环境 */
export const KF_BACKEND = 'https://www.zjzy.org.cn';

/**
 * WS 后端根地址（自动从 KF_BACKEND 派生：http→ws, https→wss）。
 * KF_BACKEND 为空时回退到当前浏览器地址，由 nginx 同域反代。
 */
export const KF_WS_BASE = KF_BACKEND
    ? KF_BACKEND.replace(/^http/, 'ws')
    : (typeof window !== 'undefined' && window.location
        ? (window.location.protocol === 'https:' ? 'wss:' : 'ws:') + '//' + window.location.host
        : '')

/** HTTP 后端根地址（KF_BACKEND 为空时回退到当前浏览器 origin） */
export const KF_HTTP_BASE = KF_BACKEND
    ? KF_BACKEND
    : (typeof window !== 'undefined' && window.location ? window.location.origin : '')
